<template>
  <div style="position: relative">
    <CRow>
      <CCol sm="9">
        <h4 class>{{ $t('settings.security.component.email.title') }}</h4>
        <div class="border-line"></div>
        <div class="mt-2">
          <CRow>
            <CCol sm="7">
              <CInput
                type="email"
                maxlength="255"
                id="email"
                addLabelClasses="mb-0 required"
                autocomplete="off"
                :label="$t('settings.security.component.email.labelInput')"
                :value.sync="userEmail"
                :disabled="confirmEmailPopUp"
              />
            </CCol>
          </CRow>
          <CRow class="mt-1">
            <CCol>
              <CButton
                type="button"
                color="primary"
                class="py-2 px-5"
                style="padding: 12px 0px"
                @click="sendEmailToken"
                :disabled="userButtonValidate"
                >{{ $t('settings.security.component.email.button.validade') }}</CButton
              >
            </CCol>
          </CRow>
        </div>
      </CCol>
    </CRow>
    <transition name="fade" v-if="confirmEmailPopUp">
      <div class="dataTable__popUp popUp" style="margin-top: -45px">
        <div class="popUp__body shadow-sm">
          <div class="confirmationDelete">
            <div class="confirmationDelete__header">
              <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                {{ $t('settings.profile.security.text.recieveConfirmation') }}
                <br />{{ $t('settings.profile.security.text.enterCode') }}
              </p>
              <p style="color: #b0b0b0">
                {{ $t('settings.profile.security.text.didNotReceiveToken') }}
                <br />
                <span @click="resendEmailToken" style="text-decoration: underline; cursor: pointer">{{
                  $t('settings.profile.security.text.sendAgain')
                }}</span>
              </p>
            </div>
            <div class="confirmationDelete__body mb-4">
              <input type="text" class="form-control" v-model="validationCode" />
            </div>
            <div class="confirmationDelete__footer">
              <div class="confirmationDelete__actions">
                <CButton color="white" class="py-2 px-5 mr-3" :disabled="loading" @click="closeConfirmEmailPopUp" type="link">
                  {{ $t('settings.profile.security.button.cancel') }}
                </CButton>
                <CButton color="primary" class="py-2 px-5" :disabled="loading" @click="updateUserEmail">
                  {{ $t('settings.profile.security.button.confirm') }}
                </CButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import services from '@/services.js'

export default {
  mounted() {
    this.userEmail = this.$store.state.auth.session.user.email
  },
  data() {
    return {
      userEmail: null,
      userButtonValidate: false,
      userPhoneSentToken: null,
      confirmEmailPopUp: false,
      validationCode: '',
      resendControll: false,
      loading: false,
    }
  },
  methods: {
    sendEmailToken() {
      let body = {
        email: this.userEmail,
      }
      this.userButtonValidate = true
      this.userPhoneSentToken = this.userEmail

      let userID = this.$store.state.auth.user.id

      services
        .sendTokenToChangeEmail(userID, body)
        .then(() => {
          this.$emit('showMessage', {
            status: 'success',
            text: this.$t('settings.security.message.success.token-email-provided'),
          })

          this.confirmEmailPopUp = true
          this.validationCode = ''
        })
        .catch(() => {
          this.$emit('showMessage', {
            status: 'danger',
            text: this.$t('settings.security.message.danger.email-already'),
          })
        })
        .finally(() => {
          this.userButtonValidate = false
        })
    },

    resendEmailToken() {
      if (this.resendControll) {
        return
      }

      let body = {
        email: this.userEmail,
      }
      this.userButtonValidate = true
      this.userPhoneSentToken = this.userEmail

      let userID = this.$store.state.auth.user.id

      this.resendControll = true

      services
        .sendTokenToChangeEmail(userID, body)
        .then(() => {
          this.$emit('showMessage', {
            status: 'success',
            text: this.$t('settings.security.message.success.token-email-provided'),
          })
        })
        .catch(() => {
          this.$emit('showMessage', {
            status: 'danger',
            text: this.$t('settings.security.message.danger.email-already'),
          })
        })
        .finally(() => {
          this.userButtonValidate = false
          setTimeout(() => {
            this.resendControll = false
          }, 5000)
        })
    },

    updateUserEmail() {
      let body = {
        email: this.userEmail,
        validationCode: this.validationCode,
      }

      let userID = this.$store.state.auth.user.id

      this.loading = true
      services
        .updateUserEmail(userID, body)
        .then(() => {
          this.confirmEmailPopUp = false
          this.userButtonValidate = false
          sessionStorage.userEmail = this.userEmail
          this.$emit('showMessage', {
            status: 'success',
            text: this.$t('settings.security.message.success.token-email-success'),
          })
        })
        .catch(() => {
          this.$emit('showMessage', {
            status: 'danger',
            text: this.$t('settings.security.message.danger.token-email-error'),
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    closeConfirmEmailPopUp() {
      this.confirmEmailPopUp = false
      this.userButtonValidate = false
    },
  },
}
</script>
